import { supabase } from './supabase'

/**
 * Resolve the single merchant row the app should use for an owner.
 *
 * Historically a flaky login flow could create more than one merchant row for
 * the same owner_id. Until those rows are cleaned up and a unique index is in
 * place, every owner-based lookup in the app must pick the SAME row, or the
 * user ends up seeing different data (or nothing) depending on which page
 * they land on. We always choose the oldest row (the original sign-up), with
 * id as a tiebreaker so the choice is fully deterministic.
 *
 * Returns the row (with the requested columns) or null when the owner has no
 * merchant yet. Throws on any transport/DB error so callers can fail closed
 * instead of mistaking "unknown" for "no merchant".
 */
export async function getMerchantForOwner(ownerId, columns = 'id') {
	if (!ownerId) return null
	const { data, error } = await supabase
		.from('merchant')
		.select(columns)
		.eq('owner_id', ownerId)
		.order('created_at', { ascending: true })
		.order('id', { ascending: true })
		.limit(1)
	if (error) throw error
	return data?.[0] ?? null
}
